import {
    UPDATE_GPS_LOCATION,
  } from "../store/types";
  
  const INITIAL_STATE = {
    location: null,
    error:false
  }
export const gpsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_GPS_LOCATION:
            if (action.payload && action.payload.error === true) {
                return {
                    location: state.location,
                    error: true
                };
            }
            if (action.payload && action.payload.error === false) {
                return {
                    location: state.location,
                    error: false
                };
            }
            return {
                location: action.payload && action.payload.lat? action.payload : null,
                error: action.payload && action.payload.lat? false : true
            };
        default:
            return state;
    }
};
